<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.page_content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: rgb(247, 247, 247);
  .eq {
    height: 100%;
    background: white;
    padding: 20px;
    box-sizing: border-box;
    .infos {
      position: relative;

      .name {
        font-size: 32px;
        font-weight: bold;
      }

      .sn {
        font-size: 16px;
        color: #999999;
      }
      .shengchan {
        margin-top: 20px;
        .params {
          .param {
            margin-bottom: 10px;
            display: flex;
            flex-flow: wrap;
            font-size: 16px;
            text-align: center;
            line-height: 20px;
            .title {
              color: black;
              flex-shrink: 0;
              font-weight: bold;
            }

            .value {
              color: #999999;
            }
          }
        }

        .chanliang {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .left {
            display: flex;
            flex-flow: wrap;
            font-size: 20px;
            font-weight: bold;
            line-height: 20px;

            .title {
              flex-shrink: 0;
            }

            .value {
            }
          }
          .right {
            .yuan {
              padding: 4px 12px;
              border-radius: 4px;
              background-color: $c-success;
              color: white;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-weight: bold;
              font-size: 16px;
              .percent {
                font-size: 28px;
              }
            }
          }
        }
      }

      .state {
        position: absolute;
        top: 5px;
        right: 0px;
        color: #41b762;
        background-color: rgba($color: #41b762, $alpha: 0.2);
        height: 40px;
        width: 80px;
        font-size: 18px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .run {
        color: $c-success;
        background-color: rgba($color: #41b762, $alpha: 0.2);
      }

      .error {
        color: $c-error;
        background-color: rgba($color: #f67171, $alpha: 0.2);
      }

      .idle {
        color: $c-warning;
        background-color: rgba($color: #edcb29, $alpha: 0.2);
      }

      .offline {
        color: $c-info;
        background-color: rgba($color: #9d9d9d, $alpha: 0.2);
      }
    }
  }
}
</style>
<template>
  <div v-loading="loading" class="page_content" ref="page_content">
    <div class="eq">
      <div v-if="eq" class="infos">
        <div class="name">{{ eq.name }}</div>
        <!-- <div class="sn">{{ $t('设备sn') }}:{{ eq.equipmentSn }}</div> -->
        <div class="shengchan" v-if="Object.keys(productionInfo).length > 0">
          <div class="params">
            <div class="param">
              <div class="title">{{ $t('chanpinmingcheng') }}:</div>
              <div class="value">{{ productionInfo.productionName }}</div>
            </div>
            <div class="param">
              <div class="title">{{ $t('mujubianma') }}:</div>
              <div class="value">{{ productionInfo.modelName }}</div>
            </div>
            <div class="param">
              <div class="title">{{ $t('biaozhun/shishizhouqi') }}:</div>
              <div class="value">{{ (productionInfo.standardCycle ? productionInfo.standardCycle.toFixed(2) : '-') + '/' + (productionInfo.cycleTime ? productionInfo.cycleTime.toFixed(2) : '-') }}</div>
            </div>
            <div class="param" v-if="false">
              <div class="title">{{ $t('yvjiwangongshijian') }}:</div>
              <div class="value">{{ productionInfo.planEndDate | time('YYYY-MM-DD HH:mm:ss') }}</div>
            </div>
          </div>
          <div class="chanliang">
            <div class="left">
              <div class="title">{{ $t('shiji/jihuachanliang') }}:</div>
              <div class="value">{{ productionInfo.productsQty + '/' + productionInfo.planQty }}</div>
            </div>

            <div class="right">
              <div class="yuan">
                <span class="percent">{{ productionInfo.progress | number(1) }}</span>
                {{ $t('生产进度') }}
                <br />
              </div>
            </div>
          </div>
        </div>

        <div
          @click="$emit('showProduce')"
          class="state"
          :class="{
            run: eq.codePointsMap['CurrentState'].v == 0 || eq.codePointsMap['CurrentState'].v == 2,
            error: eq.codePointsMap['CurrentState'].v == 3,
            offline: eq.codePointsMap['CurrentState'].v == -1 || eq.codePointsMap['CurrentState'].v == undefined,
            idle: eq.codePointsMap['CurrentState'].v == 1
          }"
        >
          <span v-if="eq.codePointsMap['CurrentState'].v == 0 || eq.codePointsMap['CurrentState'].v == 2">{{ $t('yunxing') }}</span>
          <span v-if="eq.codePointsMap['CurrentState'].v == 1">{{ $t('kongxian') }}</span>
          <span v-if="eq.codePointsMap['CurrentState'].v == 3">{{ $t('guzhang') }}</span>
          <span v-if="eq.codePointsMap['CurrentState'].v == -1 || eq.codePointsMap['CurrentState'].v == undefined">{{ $t('lixian') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gongdan_eq',
  components: {},
  props: {
    sn: {
      type: String,
      default: ''
    },
    timer: null
  },

  data() {
    return {
      productionInfo: {},
      loading: false
    };
  },

  computed: {
    ...Vuex.mapState(['equipmentsMap']),
    eq() {
      return this.equipmentsMap[this.sn];
    }
  },
  watch: {
    sn(n, o) {
      if (n != o) {
        this.refreshEq();
      }
    }
  },
  created() {
    this.refreshEq();
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  methods: {
    ...Vuex.mapActions(['refreshEqData']),
    // ...mapMutations(['updatePointMtt', 'changeSn']),
    refreshEq() {
      if (this.sn == null || this.sn == '') {
        return;
      }
      let snPointArr = [];
      snPointArr.push({
        sn: this.sn,
        nodes: ['CurrentState']
      });
      let delay = 0;

      this.loading = true;
      Promise.all([
        //获取生产进度
        this.getProductionInfo(),
        //刷新设备数据
        this.refreshEqData({
          snPointArr,
          delay
        })
      ])
        .then(res => {
          this.productionInfo = res[0];
          this.loading = false;
        })
        .catch(() => {
          //失败的话三秒后再请求设备信息
          setTimeout(() => {
            this.refreshEq();
          }, 3000);
        });
    },

    getProductionInfo() {
      return this.http
        .post(
          '/production/app/getProductionInfo?' +
            this.qs.stringify({
              cellNo: this.sn
            })
        )
        .then(res => {
          return res;
        });
    }
  }
};
</script>
